import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Typography
} from '@material-ui/core';
import PowerIcon from '@material-ui/icons/Power';
import PropTypes from 'prop-types';

const TotalDataVolume = ({ rz1, rz1totalyearkw, year, ...rest }) => (
  <Card {...rest}>
    <CardContent>
    <Grid
        container
        spacing={3}
        sx={{ justifyContent: 'space-between' }}
      >
        <Grid item>
        <Typography
            color="#4a4a4a"
            gutterBottom
            variant="h6"
          >
           {rz1}
          </Typography>
          
          <Typography
            color="#4a4a4a"
            variant="h3"
          >
            {new Intl.NumberFormat("de-DE").format(rz1totalyearkw)} kWh
          </Typography>
          <Typography
            color="#4a4a4a"
            gutterBottom
            variant="h6"
          >
            GESAMTVERBRAUCH IT {year}
          </Typography>
        </Grid>
        <Grid item>
          <Avatar
            sx={{
              backgroundColor: '#1b66b3',
              color: '#fce531',
              height: 56,
              width: 56
            }}
          >
            <PowerIcon />
          </Avatar>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

TotalDataVolume.propTypes = {
  totalDataVolume: PropTypes.any
};

export default TotalDataVolume;
